import React, { useEffect, useState } from "react";
import HttpClient from "../../utils/HttpClient";
import { Helmet } from "react-helmet-async";
import ProfileCard from "./ContactProfileCard";
import NoRecordFoundMessage from "./NoRecordFound";
import InvitationCard from "./InvitationCard";
import LoadMoreButton from "../SearchHome/LoadMoreButton";
import SearchTermBox from "./SearchTermBox";
import { useDispatch, useSelector } from "react-redux";
import { addSearch } from "../../Redux/Slice/PostSlice";

function ContactDirectory() {
    const [TypeOFSavedContacts, setTypeOFSavedContacts] = useState("All");
    const [ProfileType, setProfileType] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [invitations, setInvitations] = useState([]);
    const { inputSearch } = useSelector((state) => state.app);
    const [showLoader, setShowLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [selectedTabId, setSelectedTabId] = useState("all");
    const dispatch = useDispatch();

    useEffect(() => {
        getProfileType();
        getContactsByType({ key: 'all' });
        getPendingInvitations();
    }, []);

    useEffect(() => {
        getContactsByType({ key: 'all', search: inputSearch });
    }, [inputSearch]);

    const handleTabClick = (name, item) => {
        setTypeOFSavedContacts(item?.name);
        const key = item?._id && item?._id != 99 ? item?._id : 'all';
        setSelectedTabId(key);
        getContactsByType({ key, search: inputSearch, limit: 20 });
        // getContactsByType({ key: 'all', search: inputSearch, limit: 10 });
        getPendingInvitations();
    };

    const getProfileType = async () => {
        // const res = await HttpClient.requestData("get-profile-type", "GET", {});
        const res = await HttpClient.requestData("get-connection-profile-type", "GET", {});
        if (res && res?.status) {
            res.data.unshift({ _id: 0, name: "All", key: "all" });
            res.data.push({ _id: 99, name: "Invitation", key: "Invitation" });
            setProfileType(res.data);
        }
    };

    const getContactsByType = async (data, appendResult = false) => {
        // const response = await HttpClient.requestData("get-userby-key", "POST", data);
        const response = await HttpClient.requestData("connections", "POST", data);
        if (appendResult) {
            setContactList((prevData) => [...prevData, ...response?.data]);
        } else {
            setContactList(response.data)
        }
        setTotalPages(response?.pagination?.total);
        setCurrentPage(response?.pagination?.page);
        setHasMore(response?.pagination?.hasMore);
    }

    const getPendingInvitations = async () => {
        const response = await HttpClient.requestData("pending-directory", "GET", {});
        if (response && response?.status) {
            setInvitations(response?.data || []);
        }
    };

    const handleReloadContactList = () => {
        getProfileType();
        getContactsByType({ key: 'all' });
        getPendingInvitations();
    }

    // const calculateCount = (item) => {
    //     let count = 0;
    //     if (item?.name === 'All') {
    //         // return contactList.length;
    //         return totalPages || 0;
    //     }
    //     if (item?.name === 'Invitation') {
    //         return invitations.length;
    //     }
    //     if (contactList.length === 0) {
    //         return 0;
    //     }
    //     contactList?.forEach(contact => {
    //         if (contact?.nonmemberDetails?.profileTypeID === item?._id) {
    //             count++;
    //         }
    //     });
    //     return count;
    // }

    const calculateCount = (item) => {
        if (!item || typeof item !== 'object') {
            return 0;
        }

        const itemName = item.name;
        if (itemName === 'All') {
            if (Array.isArray(ProfileType)) {
                const totalCount = ProfileType.reduce((sum, pType) => {
                    const memberCount = pType?.memberCount || 0;
                    return sum + memberCount;
                }, 0);
                return totalCount;
            }
            return 0;
        } else if (itemName === 'Invitation') {
            return Array.isArray(invitations) ? invitations.length : 0;

        } else {
            return item.memberCount && typeof item.memberCount === 'number'
                ? item.memberCount
                : 0;
        }
    };

    // useEffect(() => {
    //     if (TypeOFSavedContacts) {
    //         getProfileType();
    //         getContactsByType({ key: 'all' });
    //         getPendingInvitations();
    //     }
    // }, [TypeOFSavedContacts]);

    const handleReloadInvitationList = () => {
        getContactsByType({ key: 'all' });
        getPendingInvitations();
    }

    const loadMore = () => {
        getContactsByType({ key: selectedTabId, search: inputSearch, page: currentPage + 1, limit: 20 }, true);
        // getContactsByType({ key: 'all', search: inputSearch, page: currentPage + 1, limit: 10 }, true);
    }

    const handleSearchTermRemove = () => {
        dispatch(addSearch(''));
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Neoo Search Directory Page</title>
            </Helmet>

            <section className="container-fluid contactlist owncontactlist min-vh-100 container-contact-dir">
                <div
                    className="contactlistmainpage"
                // onClick={(e) => setClickedIndex(null)}
                >
                    <div className="cust_container">
                        <div className="mnakmsjjmn">
                            {/* cont-sub-section  */}
                            <div className="fhjsdcncth">
                                {ProfileType &&
                                    ProfileType?.map((item, index) => (
                                        <div className="" key={index}>
                                            <div
                                                key={index}
                                                className={
                                                    TypeOFSavedContacts === item?.name
                                                        ? "ttxytnk active"
                                                        : "ttxytnk"
                                                }
                                                onClick={() => handleTabClick(item?.name, item)}
                                            >
                                                {item?.name} ({calculateCount(item)})
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            <SearchTermBox searchTerm={inputSearch} onRemove={handleSearchTermRemove} />

                            <div className="contactbg">
                                {TypeOFSavedContacts == 'All' && (
                                    <div>
                                        {contactList.length > 0 && contactList.map((contact, idx) => (
                                            <ProfileCard key={idx} contact={contact} reloadContactList={handleReloadContactList} />
                                        ))}
                                        {contactList.length === 0 && <NoRecordFoundMessage key={TypeOFSavedContacts} message="No contacts found." />}
                                        <LoadMoreButton onLoadMore={loadMore} loading={showLoader} hasMore={hasMore} />
                                    </div>
                                )}

                                {ProfileType && ProfileType?.map((item, index) => (
                                    item?.name !== "All" && item?.name !== "Invitation" && TypeOFSavedContacts == item?.name && (
                                        <div key={index}>
                                            {/* {contactList.length > 0 && contactList.map((contact, idx) => (
                                                contact?.nonmemberDetails?.profileTypeID === item._id && (
                                                    <ProfileCard contact={contact} reloadContactList={handleReloadContactList} />
                                                )
                                            ))} */}

                                            {contactList.length > 0 && contactList.map((contact, idx) => (
                                                <ProfileCard contact={contact} reloadContactList={handleReloadContactList} />
                                            ))}

                                            {/* {contactList.filter(contact => contact?.nonmemberDetails?.profileTypeID === item._id).length === 0 && <NoRecordFoundMessage key={TypeOFSavedContacts} message="No contacts found." />} */}
                                            {contactList.length === 0 && <NoRecordFoundMessage key={TypeOFSavedContacts} message="No contacts found." />}
                                            <LoadMoreButton onLoadMore={loadMore} loading={showLoader} hasMore={hasMore} />
                                        </div>
                                    )
                                ))}

                                {TypeOFSavedContacts == 'Invitation' && (
                                    <div>
                                        {invitations.length > 0 && invitations.map((contact, idx) => (
                                            <InvitationCard key={idx} contact={contact} reloadInvitationList={handleReloadInvitationList} />
                                        ))}
                                        {invitations.length === 0 && <NoRecordFoundMessage message="No invitations found." />}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ContactDirectory;